import {
  Component, ViewContainerRef, ViewChild, ReflectiveInjector, ComponentFactoryResolver, Input,
  EventEmitter, Output, AfterViewInit
} from '@angular/core';
import { ShopifyAddJavascriptComponent } from '../content/shopify/shopify_add_javascript.component';
import { InstallConversionTrackingComponent } from '../content/shopify/install_conversion_tracking.component';
import { InstallReviewsWidgetComponent } from '../content/shopify/install_reviews_widget.component';
import { WooSetupComponent } from '../content/woocommerce/woo_setup.component';
import { WooAddJavascriptComponent } from '../content/woocommerce/woo_add_javascript.component';
import { WooActivatePluginComponent } from '../content/woocommerce/woo_activate_plugin.component';
import { BigcommerceInstallTrackingComponent } from '../content/bigcommerce/bigcommerce_install_tracking.component';
import { BigcommerceInstallAppComponent } from '../content/bigcommerce/bigcommerce_install_app.component';
import { BigcommerceBuiltinReviewsComponent } from '../content/bigcommerce/bigcommerce_builtin_reviews.component';
import { BigcommerceInstallWidgetComponent } from '../content/bigcommerce/bigcommerce_install_widget.component';
import { Magento1LoadPastPurchasesComponent } from '../content/magento1/magento1_load_past_purchases.component';
import { Magento1DisableCompilationComponent } from '../content/magento1/magento1_disable_compilation.component';
import { Magento1InstallYotpoWidgetComponent } from '../content/magento1/magento1_install_yotpo_widget.component';
import { Magento1ReenableCompilationComponent } from '../content/magento1/magento1_reenable_compilation.component';
import { Magento1DisableBuiltinReviewsComponent } from '../content/magento1/magento1_disable_builtin_reviews.component';
import { Magento1InstallExtensionComponent } from '../content/magento1/magento1_install_extension.component';
import { Magento2EnableYotpoModuleComponent } from '../content/magento2/magento2_enable_yotpo_module.component';
import { AccordionItemClass } from '../accordion_item';

@Component({
  selector: 'yi-dynamic-component',
  entryComponents: [ShopifyAddJavascriptComponent, InstallConversionTrackingComponent,
    InstallReviewsWidgetComponent, WooAddJavascriptComponent, WooActivatePluginComponent,
    WooSetupComponent, BigcommerceBuiltinReviewsComponent, BigcommerceInstallAppComponent,
    BigcommerceInstallWidgetComponent, BigcommerceInstallTrackingComponent, Magento1DisableCompilationComponent,
    Magento1InstallExtensionComponent, Magento1InstallYotpoWidgetComponent, Magento1LoadPastPurchasesComponent,
    Magento1DisableBuiltinReviewsComponent, Magento1ReenableCompilationComponent ,
    Magento2EnableYotpoModuleComponent],
  template: `
    <div #dynamicComponentContainer ></div>
  `,
})
export default class DynamicComponent implements AfterViewInit {

  @Output() item: any;
  @Output() openNext: any = new EventEmitter();

  currentComponent = null;
  private localData;

  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef }) dynamicComponentContainer: ViewContainerRef;

  @Input() set componentData(data: AccordionItemClass) {
    this.localData = data;
  }

  constructor(private resolver: ComponentFactoryResolver) {
  }

  ngAfterViewInit(): void {
    if (!this.localData) {
      return;
    }

    // Inputs need to be in the following format to be resolved properly
    let inputProviders = [ {provide: AccordionItemClass, useValue: this.localData} ];
    let resolvedInputs = ReflectiveInjector.resolve(inputProviders);

    // We create an injector out of the data we want to pass down and this components injector
    let injector = ReflectiveInjector.fromResolvedProviders(resolvedInputs, this.dynamicComponentContainer.parentInjector);

    // We create a factory out of the component we want to create
    let factory = this.resolver.resolveComponentFactory(this.localData.getTemplateUrl());

    // We create the component using the factory and the injector
    let component = factory.create(injector);
    component.instance['item'] = this.localData;

    (component.instance as any).openNextItem.subscribe(item => {
      this.openNext.emit(item);
    });
    // We insert the component into the dom container
    this.dynamicComponentContainer.insert(component.hostView);

    // Destroy the previously created component
    if (this.currentComponent) {
      this.currentComponent.destroy();
    }

    this.currentComponent = component;
  }
}
